<template>
    <div
        v-if="show"
        class="pointer-events-none fixed z-50 inset-x-0 bottom-20 lg:bottom-6 px-3"
    >
      <div class="pointer-events-auto mx-auto max-w-xl rounded-xl bg-bc-red p-6 shadow-lg flex items-start flex-col">
        <div class="bc-box-notification-content text-white w-full pb-4" v-html="notification.text"></div>
        <button 
          @click="close()"
          class="btn bg-white text-bc-red !p-1.5 !pr-3 ml-auto"
        >
          <aw-icon
            icon="close"
            class="w-5 h-5"
          />
          {{$t('Dismiss')}}
        </button>
      </div>
    </div>
</template>

<script>
export default {
  props: {
    notification: {
      type: Object,
      default: null,
    }
  },
  data() {
    return {
      show: false
    }
  },
  methods: {
    close() {
      window.sessionStorage.setItem('bcNotificationID', this.notification.hash)
      this.show = false
    }
  },
  mounted() {
    if (this.notification && this.notification.hash != window.sessionStorage.getItem('bcNotificationID')) {
      this.show = true
    }
  }
}
</script>

<style lang="scss">
  .bc-box-notification-content {
    p {
      @apply text-base leading-6 pb-2;
    }

    h2 {
      @apply text-2xl font-bold leading-6 pb-4;
    }
    
    h3 {
      @apply text-xl font-bold leading-6 pb-4;
    }

    h3 {
      @apply text-lg font-bold leading-6 pb-4;
    }
  }
</style>
